import type { PoetryWork } from "./types";

export const FIXTURE_RELEASE = "fixture-poetry-v2";

const publicDomain = (url: string) => [{
  component: "original_work",
  status: "active",
  basis: "Public-domain source text; this normalized edition is reviewed separately.",
  source_url: url,
}];

const source = (id: string, name: string, locator: string) => ({ id, name, locator });

export const FIXTURE_WORKS: PoetryWork[] = [
  {
    id: "work_jing_ye_si",
    edition_id: "edition_jing_ye_si",
    title: "静夜思",
    language: "zh-Hans",
    creators: [{ id: "person_li_bai", name: "李白" }],
    citation: { id: "xhalo:poetry:work_jing_ye_si", label: "李白《静夜思》", source_locator: "https://github.com/chinese-poetry/chinese-poetry" },
    text: "床前明月光，\n疑是地上霜。\n举头望明月，\n低头思故乡。",
    content_sha256: "f1f0f65237dec7f22ed56bdb3c6d1f5e69f728652ef2979e9de9bc8cddcded92",
    source: source("source_chinese_poetry", "Chinese Poetry", "https://github.com/chinese-poetry/chinese-poetry"),
    rights: publicDomain("https://github.com/chinese-poetry/chinese-poetry/blob/master/LICENSE"),
    extensions: { poetry: { dynasty: "唐代", form: "五言绝句", themes: ["思乡", "月夜"] } },
  },
  {
    id: "work_chun_xiao",
    edition_id: "edition_chun_xiao",
    title: "春晓",
    language: "zh-Hans",
    creators: [{ id: "person_meng_haoran", name: "孟浩然" }],
    citation: { id: "xhalo:poetry:work_chun_xiao", label: "孟浩然《春晓》", source_locator: "https://github.com/chinese-poetry/chinese-poetry" },
    text: "春眠不觉晓，\n处处闻啼鸟。\n夜来风雨声，\n花落知多少。",
    content_sha256: "2fbfca4c6af68fb5539e2a92ab8bf8fa4463ad65a0a9f29f3833293919a57556",
    source: source("source_chinese_poetry", "Chinese Poetry", "https://github.com/chinese-poetry/chinese-poetry"),
    rights: publicDomain("https://github.com/chinese-poetry/chinese-poetry/blob/master/LICENSE"),
    extensions: { poetry: { dynasty: "唐代", form: "五言绝句", themes: ["春天", "自然"] } },
  },
  {
    id: "work_wang_lu_shan_pu_bu",
    edition_id: "edition_wang_lu_shan_pu_bu",
    title: "望庐山瀑布",
    language: "zh-Hans",
    creators: [{ id: "person_li_bai", name: "李白" }],
    citation: { id: "xhalo:poetry:work_wang_lu_shan_pu_bu", label: "李白《望庐山瀑布》", source_locator: "https://github.com/chinese-poetry/chinese-poetry" },
    text: "日照香炉生紫烟，\n遥看瀑布挂前川。\n飞流直下三千尺，\n疑是银河落九天。",
    content_sha256: "fixture-wang-lu-shan",
    source: source("source_chinese_poetry", "Chinese Poetry", "https://github.com/chinese-poetry/chinese-poetry"),
    rights: publicDomain("https://github.com/chinese-poetry/chinese-poetry/blob/master/LICENSE"),
    extensions: { poetry: { dynasty: "唐代", form: "七言绝句", themes: ["山水", "自然"] } },
  },
  {
    id: "work_shui_diao_ge_tou",
    edition_id: "edition_shui_diao_ge_tou",
    title: "水调歌头·明月几时有",
    language: "zh-Hans",
    creators: [{ id: "person_su_shi", name: "苏轼" }],
    citation: { id: "xhalo:poetry:work_shui_diao_ge_tou", label: "苏轼《水调歌头·明月几时有》", source_locator: "https://github.com/chinese-poetry/chinese-poetry" },
    text: "明月几时有？把酒问青天。\n不知天上宫阙，今夕是何年。\n我欲乘风归去，又恐琼楼玉宇，高处不胜寒。\n起舞弄清影，何似在人间。",
    content_sha256: "fixture-shui-diao-ge-tou",
    source: source("source_chinese_poetry", "Chinese Poetry", "https://github.com/chinese-poetry/chinese-poetry"),
    rights: publicDomain("https://github.com/chinese-poetry/chinese-poetry/blob/master/LICENSE"),
    extensions: { poetry: { dynasty: "宋代", form: "词", themes: ["明月", "人生"] } },
  },
  {
    id: "work_ru_meng_ling",
    edition_id: "edition_ru_meng_ling",
    title: "如梦令·常记溪亭日暮",
    language: "zh-Hans",
    creators: [{ id: "person_li_qingzhao", name: "李清照" }],
    citation: { id: "xhalo:poetry:work_ru_meng_ling", label: "李清照《如梦令》", source_locator: "https://github.com/chinese-poetry/chinese-poetry" },
    text: "常记溪亭日暮，沉醉不知归路。\n兴尽晚回舟，误入藕花深处。\n争渡，争渡，惊起一滩鸥鹭。",
    content_sha256: "fixture-ru-meng-ling",
    source: source("source_chinese_poetry", "Chinese Poetry", "https://github.com/chinese-poetry/chinese-poetry"),
    rights: publicDomain("https://github.com/chinese-poetry/chinese-poetry/blob/master/LICENSE"),
    extensions: { poetry: { dynasty: "宋代", form: "词", themes: ["回忆", "自然"] } },
  },
  {
    id: "work_chun_wang",
    edition_id: "edition_chun_wang",
    title: "春望",
    language: "zh-Hans",
    creators: [{ id: "person_du_fu", name: "杜甫" }],
    citation: { id: "xhalo:poetry:work_chun_wang", label: "杜甫《春望》", source_locator: "https://github.com/chinese-poetry/chinese-poetry" },
    text: "国破山河在，城春草木深。\n感时花溅泪，恨别鸟惊心。\n烽火连三月，家书抵万金。\n白头搔更短，浑欲不胜簪。",
    content_sha256: "fixture-chun-wang",
    source: source("source_chinese_poetry", "Chinese Poetry", "https://github.com/chinese-poetry/chinese-poetry"),
    rights: publicDomain("https://github.com/chinese-poetry/chinese-poetry/blob/master/LICENSE"),
    extensions: { poetry: { dynasty: "唐代", form: "五言律诗", themes: ["家国", "春天"] } },
  },
  {
    id: "work_sonnet_18",
    edition_id: "edition_sonnet_18",
    title: "Sonnet 18",
    language: "en",
    creators: [{ id: "person_william_shakespeare", name: "William Shakespeare" }],
    citation: { id: "xhalo:poetry:work_sonnet_18", label: "William Shakespeare, Sonnet 18", source_locator: "https://www.gutenberg.org" },
    text: "Shall I compare thee to a summer’s day?\nThou art more lovely and more temperate:\nRough winds do shake the darling buds of May,\nAnd summer’s lease hath all too short a date.",
    content_sha256: "fixture-sonnet-18",
    source: source("source_gutenberg", "Project Gutenberg", "https://www.gutenberg.org"),
    rights: publicDomain("https://www.gutenberg.org/policy/permission.html"),
    extensions: { poetry: { period: "English Renaissance", form: "Sonnet", themes: ["Love", "Time"] } },
  },
  {
    id: "work_hope_is_the_thing",
    edition_id: "edition_hope_is_the_thing",
    title: "“Hope” is the thing with feathers",
    language: "en",
    creators: [{ id: "person_emily_dickinson", name: "Emily Dickinson" }],
    citation: { id: "xhalo:poetry:work_hope_is_the_thing", label: "Emily Dickinson, Hope", source_locator: "https://www.gutenberg.org" },
    text: "“Hope” is the thing with feathers –\nThat perches in the soul –\nAnd sings the tune without the words –\nAnd never stops – at all –",
    content_sha256: "fixture-hope-feathers",
    source: source("source_gutenberg", "Project Gutenberg", "https://www.gutenberg.org"),
    rights: publicDomain("https://www.gutenberg.org/policy/permission.html"),
    extensions: { poetry: { period: "19th century", form: "Lyric", themes: ["Hope", "Nature"] } },
  },
  {
    id: "work_the_raven",
    edition_id: "edition_the_raven",
    title: "The Raven",
    language: "en",
    creators: [{ id: "person_edgar_allan_poe", name: "Edgar Allan Poe" }],
    citation: { id: "xhalo:poetry:work_the_raven", label: "Edgar Allan Poe, The Raven", source_locator: "https://www.gutenberg.org/ebooks/1065" },
    text: "Once upon a midnight dreary, while I pondered, weak and weary,\nOver many a quaint and curious volume of forgotten lore—\nWhile I nodded, nearly napping, suddenly there came a tapping,\nAs of some one gently rapping, rapping at my chamber door.",
    content_sha256: "1eae691c5b43d34c5c6262f7866696375be56fdb6d60228614709d486d7a5766",
    source: source("source_gutenberg", "Project Gutenberg", "https://www.gutenberg.org/ebooks/1065"),
    rights: publicDomain("https://www.gutenberg.org/policy/permission.html"),
    extensions: { poetry: { period: "19th century", form: "Narrative poem", themes: ["Memory", "Night"] } },
  },
  {
    id: "work_daffodils",
    edition_id: "edition_daffodils",
    title: "I Wandered Lonely as a Cloud",
    language: "en",
    creators: [{ id: "person_william_wordsworth", name: "William Wordsworth" }],
    citation: { id: "xhalo:poetry:work_daffodils", label: "William Wordsworth, Daffodils", source_locator: "https://www.gutenberg.org" },
    text: "I wandered lonely as a cloud\nThat floats on high o’er vales and hills,\nWhen all at once I saw a crowd,\nA host, of golden daffodils.",
    content_sha256: "fixture-daffodils",
    source: source("source_gutenberg", "Project Gutenberg", "https://www.gutenberg.org"),
    rights: publicDomain("https://www.gutenberg.org/policy/permission.html"),
    extensions: { poetry: { period: "Romantic", form: "Lyric", themes: ["Nature", "Memory"] } },
  },
];

